import styled from 'styled-components';

export const Title = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  margin-bottom: 16px;
  font-family: ${props => props.theme.fonts.display};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  font-size: 18px;
  color: ${props => props.theme.colors.textPrimary};
  border-bottom: 1.5px solid rgba(23, 26, 29, 0.1);

  @media screen and (min-width: 768px) {
    justify-content: start;
    font-size: 24px;
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 14px;
  top: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.theme.brand.canvas};
  transition: ${props => props.theme.transition.main};

  & svg {
    width: 18px;
    height: 18px;
    color: ${props => props.theme.brand.muted};
  }

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.secondary};

    & svg {
      color: ${props => props.theme.brand.chalk};
    }
  }

  @media screen and (min-width: 768px) {
    top: 18px;
    right: 18px;
    width: 40px;
    height: 40px;

    & svg {
      width: 22px;
      height: 22px;
    }
  }
`;
